package org.example.project.firebase

import dev.gitlive.firebase.auth.externals.initializeAuth
import kotlinx.coroutines.await
import org.example.project.viewmodel.GameViewModel
import kotlin.js.Promise

actual object GitHubAuth {
    actual suspend fun login(): GitHubUserInfo? {
        return try {
            println("Attempting GitHub OAuth login")
            
            // Use Firebase Web SDK directly
            val authModule = js("require('firebase/auth')")
            val firebaseAuth: dynamic = authModule.getAuth()
            val provider = js("new authModule.GithubAuthProvider()")
            
            val resultPromise: Promise<dynamic> = authModule.signInWithPopup(firebaseAuth, provider)
            val result = resultPromise.await()
            js("console.log(result)")
            js("console.dir(result)")
            js("console.log(result.user)")
            js("console.dir(result.user)")
            js("console.log(result._tokenResponse)")
            js("console.dir(result._tokenResponse)")
            
            println("GitHub login result: ${result.user?.uid}")
            
            // Extract GitHub user info from the OAuth result
            val user = result.user
            val tokenResponse = result._tokenResponse
            js("console.log('TOKEN RESPONSE:', tokenResponse)")
            js("console.log('RAW USER INFO:', tokenResponse.rawUserInfo)")

            val rawInfo =
                JSON.parse<dynamic>(
                    tokenResponse.rawUserInfo as String
                )

            val username =
                rawInfo.login as String

            val photoUrl =
                rawInfo.avatar_url as String
            
            println("GitHub username: $username, photoUrl: $photoUrl")
            
            // Wait for the auth state to be updated in Firebase
            AuthManager.waitForUserId()
            GitHubUserInfo(username, photoUrl)
        } catch (e: Exception) {
            println("GitHub Login Error: ${e.message}")
            e.printStackTrace()
            null
        }
    }
}
